import React from 'react';
import { ISbgFilterListProps, ISbgFilterListState } from './SbgFilterList.types';
import { SbgListClosed } from './SbgListClosed/SbgListClosed';
import { SbgListAvailable } from './SbgListAvailable/SbgListAvailable';
import { ToggleBoxGroup } from 'sos-common/js/components/ToggleBoxGroup/ToggleBoxGroup';
import { SbgListComming } from './SbgListComming/SbgListComming';
export class SbgFilterList extends React.Component<ISbgFilterListProps, ISbgFilterListState> {
  private filters = ['Öppna för ansökan', 'Kommande', 'Stängda för ansökan', 'Visa alla'];
  private hideHeaders = true;
  constructor(props: ISbgFilterListProps) {
    super(props);

    this.state = {
      showOpen: true,
      showClosed: false,
      showComming: false,
    };
  }

  //simple solution for checking first element without rebuilding the toggleBox element.
  componentDidMount() {
    var radioButtons = document.querySelectorAll("input[name='filtergroup']");
    if (radioButtons.length > 0) {
      var radioButton = radioButtons[0] as HTMLInputElement;
      radioButton.checked = true;
    }
  }

  onChangeFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    this.hideHeaders = true;
    switch (value) {
      case 'Öppna för ansökan':
        this.setState({
          showOpen: true,
          showClosed: false,
          showComming: false,
        });
        break;
      case 'Kommande':
        this.setState({
          showOpen: false,
          showClosed: false,
          showComming: true,
        });
        break;
      case 'Stängda för ansökan':
        this.setState({
          showOpen: false,
          showClosed: true,
          showComming: false,
        });
        break;
      case 'Visa alla':
        this.hideHeaders = false;
        this.setState({
          showOpen: true,
          showClosed: true,
          showComming: true,
        });
        break;
    }
  };

  render() {
    const { closeForApplication, availableModel, commingForApplication, isAuthenticated, loginButtonUrl } = this.props;
    const { showClosed, showComming, showOpen } = this.state;
    return (
      <div aria-live="polite" className="date-list-wrapper">
        <ToggleBoxGroup
          fieldsetCssclass="date-list-wrapper__filter"
          legendSrOnly={true}
          categoryNames={this.filters}
          onChangeCb={this.onChangeFilter}
        />

        {showOpen && (
          <SbgListAvailable
            isAuthenticated={isAuthenticated}
            hideHeading={this.hideHeaders}
            availableModel={availableModel}
            loginButtonUrl={loginButtonUrl}
          />
        )}
        {showComming && (
          <SbgListComming
            closedItems={commingForApplication}
            initialShowCount={100000}
            loadCountPerClick={5}
            hideButton={true}
            hideHeading={this.hideHeaders}
          />
        )}
        {showClosed && (
          <SbgListClosed
            closedItems={closeForApplication}
            initialShowCount={100000}
            loadCountPerClick={5}
            hideButton={true}
            hideHeading={this.hideHeaders}
          />
        )}
      </div>
    );
  }
}
